module.exports = __webpack_public_path__ + "static/media/crashed-car-mobile.a4badb75.webp";